import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'


const BoysWeightclasses = () => {
  
  const location = useLocation()
  const genderId = location.pathname.split("/")[2]
  const classificationId = location.pathname.split("/")[3]

  console.log("gender is " + genderId + " classification is " + classificationId)

  return (
    <div class="weightclass_div">
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/106`}>
          <button class="wc_button">
          106
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/113`}>
          <button class="wc_button">
          113
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/120`}>
          <button class="wc_button">
          120
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/126`}>
          <button class="wc_button">
          126
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/132`}>
          <button class="wc_button">
          132
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/138`}>
          <button class="wc_button">
          138
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/144`}>
          <button class="wc_button">
          144
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/150`}>
          <button class="wc_button">
          150
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/157`}>
          <button class="wc_button">
          157
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/165`}>
          <button class="wc_button">
          165
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/175`}>
          <button class="wc_button">
          175
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/190`}>
          <button class="wc_button">
          190
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/215`}>
          <button class="wc_button">
          215
          </button>
        </Link>
        <Link class="link_styles" to={`/rankings/${genderId}/${classificationId}/285`}>
          <button class="wc_button">
          285
          </button>
        </Link>
    </div>
  )
}

export default BoysWeightclasses